import lottie from 'lottie-web'
import { gsap, ScrollTrigger } from './cco-gsap-core';

const initializeNavbarAnimatedLogo = () => {
  const logoOuterContainer = document.querySelector('.home-link');
  const logoHeartContainer = document.getElementById('animatedNavbarLogo');
  if (!logoHeartContainer) return;

  const animationPath = pageData.navbarLogoAnimation;

  if (animationPath) {
    const animation = lottie.loadAnimation({
      container: logoHeartContainer,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: animationPath
    })

    logoOuterContainer.addEventListener('mouseenter', () => {
      animation.setDirection(1);
      animation.goToAndPlay(0, true);
    });

    logoOuterContainer.addEventListener('mouseleave', () => {
      animation.setDirection(-1);
      animation.goToAndPlay(animation.totalFrames - 1, true);
      // When reverse finishes, stop at 0
      const onReverseComplete = () => {
        animation.goToAndStop(0, true);
        animation.removeEventListener('complete', onReverseComplete);
      };
      animation.addEventListener('complete', onReverseComplete);
    });
  }
}

const initializeNavbarScrollTriggers = () => {
  const navbar = document.querySelector('.navbar-container')
  const menuWrapper = navbar.querySelector('.menu-wrapper')

  if (!menuWrapper) return
  // GSAP ScrollTrigger: Add 'scrolled' class to navbar after 100px scroll
  if (navbar) {
    ScrollTrigger.create({
      start: "top -100",
      onEnter: () => navbar.classList.add("scrolled"),
      onLeaveBack: () => navbar.classList.remove("scrolled"),
      markers: false // set to true for debugging
    });
  }
}

const initializeNavbarDropdowns = () => {
  const menuItemsWithDropdowns = document.querySelectorAll('.navbar-container .menu-wrapper .menu-item-has-children');
  
  menuItemsWithDropdowns.forEach(menuItem => {
    const dropdownToggle = menuItem.querySelector('.dropdown-toggle');

    if (dropdownToggle) {
      dropdownToggle.addEventListener('click', (e) => {
        e.preventDefault();
        menuItem.classList.toggle('dropdown-open');
      });
    } 
  });
}

const initializeNavbarDesktopSearch = () => {
  const searchContainer = document.querySelector('.desktop-search-button');
  const searchToggle = searchContainer.querySelector('.desktop-search-button .search-toggle');
  
  if (searchToggle && searchContainer) {
    searchToggle.addEventListener('click', () => {
      searchContainer.classList.toggle('open');
    });
  }
}

const initializeNavbarMobileSearch = () => {
  const mobileSearchToggle = document.querySelector('.mobile-search-toggle-container .search-toggle');
  const mobileSearchBar = document.querySelector('.mobile-search-bar');

  if (mobileSearchToggle && mobileSearchBar) {
    mobileSearchToggle.addEventListener('click', () => {
      console.log('Toggling mobile search bar');
      mobileSearchBar.classList.toggle('open');
      mobileSearchToggle.classList.toggle('active');
    });
  }
}

const initializeSearchFormValidation = () => {
  // Handle all search forms to prevent submission when empty
  const searchForms = document.querySelectorAll('.search-form, form[role="search"]');
  
  searchForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      const searchInput = form.querySelector('input[type="search"], .search-field, .search-input');
      
      if (searchInput && !searchInput.value.trim()) {
        e.preventDefault();
        searchInput.focus();
        return false;
      }
    });

    // Also handle direct clicks on submit buttons
    const submitButtons = form.querySelectorAll('button[type="submit"], .search-submit');
    submitButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const searchInput = form.querySelector('input[type="search"], .search-field, .search-input');
        
        if (searchInput && !searchInput.value.trim()) {
          e.preventDefault();
          searchInput.focus();
          return false;
        }
      });
    });
  });
}

export const initializeNavbar = () => {
  const navbar = document.querySelector('.navbar-container')
  const navbarToggleButton = navbar.querySelector('.mobile-navbar .navbar-toggler')

  if (!navbarToggleButton) return

  navbarToggleButton.addEventListener('click', () => {
    navbar.classList.toggle('open')
  })

  initializeNavbarScrollTriggers()
  initializeNavbarDropdowns()
  initializeNavbarAnimatedLogo()
  initializeNavbarDesktopSearch()
  initializeNavbarMobileSearch()
  initializeSearchFormValidation()
}